(function(){
  if(window.innerWidth>749)return;
  const pf=document.querySelector('product-info');if(!pf)return;
  const bb=document.querySelector('.product-form__buttons');if(!bb)return;
  const bar=document.createElement('div');bar.className='aiof-sticky-cart';
  const t=document.querySelector('.product__title h1');
  const p=document.querySelector('.price__regular .price-item--regular');
  bar.innerHTML='<span class="aiof-sticky-cart__title">'+(t?t.textContent.trim():'')+'</span><span class="aiof-sticky-cart__price">'+(p?p.textContent.trim():'')+'</span><button class="aiof-sticky-cart__btn" type="button">Agregar al Carrito</button>';
  document.body.appendChild(bar);
  const obs=new IntersectionObserver(entries=>{entries.forEach(e=>{bar.classList.toggle('visible',!e.isIntersecting);});},{threshold:0});
  obs.observe(bb);
  bar.querySelector('.aiof-sticky-cart__btn').addEventListener('click',()=>{const b=document.querySelector('[name="add"]');if(b)b.click();});
})();
